import React, { Component } from "react";
import Feathers from "../redux/FeathersRedux";
import TableHeader, {
  Grid,
  Table,
  Header,
  Image,
  Button,
  Form,
  Label,
  Popup,
  Icon,
} from "semantic-ui-react";
import Config from "../config/index";
import swal from "sweetalert2";
import ConfigStages from "../config/etapas-ahuladorodillos";
import moment from "moment";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import { laravelService } from "../utils/laravelService";
import CheckModal from "../components/Check/CheckModal";
import { getStageName } from "../utils/Utils";

function getUniqueKeysBySupplier(data) {
  const result = {};

  for (const item of data) {
    const supplierId = item.proveedor_id;
    const supplierName = item.proveedor;
    const keyId = item.clave_id;

    if (!result[supplierId]) {
      result[supplierId] = {
        supplier: supplierName,
        key_ids: new Set(),
      };
    }

    result[supplierId].key_ids.add(keyId);
  }

  for (const supplierId in result) {
    result[supplierId].key_ids = Array.from(result[supplierId].key_ids);
  }

  return result;
}

class IncidenceCheckContainer extends Component {
  constructor() {
    super();

    this.state = {
      currentRow: {},
      modalOpened: false,
      rawMaterials: [],
      providers: [],
      incidence: {
        rodillo: {
          partida: {
            producto_id: null,
          },
        },
        tipoincidencia: {},
        usuario: {},
      },
      paramid: "",
      options: [
        // {
        //   text: "Revisión",
        //   value: 1,
        //   paraMancheta: 1,
        // },
        // {
        //   text: "Incidencia comercial",
        //   value: 1,
        //   paraMancheta: 1,
        // },
        {
          text: "Molino",
          value: 2,
        },
        {
          text: "Desviste",
          value: 3,
        },
        {
          text: "Construcción",
          value: 4,
          paraMancheta: 1,
        },
        {
          text: "Desbaste",
          value: 6,
        },
        {
          text: "Rectificado",
          value: 7,
        },
        {
          text: "Control de Calidad",
          value: 10000,
          paraMancheta: 1,
        },
        {
          text: "Desmonte",
          value: 9,
          paraMancheta: 1,
        },
        {
          text: "Corte",
          value: 10,
          paraMancheta: 1,
        },
        {
          text: "Producto Terminado",
          value: 9999,
          paraMancheta: 1,
        },
      ],
      stagetoSend: 0,
      textSolution: "",
    };

    this.closeModal = this.closeModal.bind(this);
  }

  async componentWillReceiveProps(nextp) {
    await this.setState({
      paramid: nextp.match.params.id,
    });
    this.fetchData();
  }

  async componentDidMount() {
    await this.setState({
      paramid: this.props.match.params.id,
    });
    await this.fetchData();
  }

  fetchDataRawMaterials = async (pedidoId) => {
    await laravelService
      .get(`inventory/rawMaterialEmails/${pedidoId}`)
      .then((res) => {
        this.setState({
          rawMaterials: res.data,
          providers: getUniqueKeysBySupplier(res.data),
        });
      })
      .catch((error) => console.log("error", error));
  };

  fetchData = () => {
    Feathers.service("incidencia")
      .find({
        query: {
          id: this.state.paramid,
        },
      })
      .then((res) => {
        this.setState(
          {
            incidence: res.data[0],
          },
          async () => {
            if (this.state.incidence.tipoincidencia.etapa === 8) {
              this.setState({
                incidence: {
                  ...this.state.incidence,
                  tipoincidencia: {
                    ...this.state.incidence.tipoincidencia,
                    etapa: 10000,
                  },
                },
              });
            }
            await this.fetchDataRawMaterials(this.state.incidence.pedido_id);
          }
        );
      });
  };

  renderTableBody = () => {
    return (
      <Table.Body>
        <Table.Row>
          <Table.Cell>
            <b>Status</b>
          </Table.Cell>
          <Table.Cell>
            <this.renderStatus />
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <b>Fecha Hora</b>
          </Table.Cell>
          <Table.Cell>{this.state.incidence.fecha_hora}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <b>Tipo de incidencia</b>
          </Table.Cell>
          <Table.Cell>{this.state.incidence.tipoincidencia.nombre}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <b>Descripción</b>
          </Table.Cell>
          <Table.Cell>{this.state.incidence.descripcion}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <b>Usuario Reportador</b>
          </Table.Cell>
          <Table.Cell>
            {this.state.incidence.usuario.nombre}{" "}
            {this.state.incidence.usuario.apellido}
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <b>Etapa</b>
          </Table.Cell>
          <Table.Cell>
            {/* use rodillo to get current stage, incidence type 24 will always have undress as its stage */}
            {this.state.incidence.tipoincidencia.id === 24
              ? getStageName(this.state.incidence.rodillo.stage)
              : ConfigStages[this.state.incidence.tipoincidencia.etapa]}
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    );
  };

  renderIncidenceImage = () => {
    if (this.state.incidence) {
      return this.state.incidence.imagen ? (
        <Image src={Config.apiUrl + "/" + this.state.incidence.imagen} />
      ) : (
        <></>
      );
    }
  };

  handleSolveButton = async () => {
    if (!this.state.stagetoSend && !this.state.stagetoSend === 2) {
      return swal(
        "¡Falta información!",
        "Indique una etapa a la incidencia actual",
        "info"
      );
    }
    if (!this.state.textSolution) {
      return swal(
        "¡Falta información!",
        "Indique una solución a la incidencia actual",
        "info"
      );
    }
    /*
            aqui es donde se handlea la opción que seleccionó el usuario 
        */

    // 3 4 6 7
    // if (this.state.stagetoSend === 1) {
    // await Feathers.service("revision").create({
    //   rodillo_id: this.state.incidence.rodillo_id,
    //   pedido_id: this.state.incidence.pedido_id,
    // });
    // const incidenciaComercialId = 23;
    // await Feathers.service("incidencia")
    //   .patch(this.state.incidence.id, {
    //     tipo_incidencia_id: incidenciaComercialId,
    //   })
    //   .then((_) => {
    //     Feathers.service("notificacion").create({
    //       mensaje: `Diametro Núcleo incorrecto en la orden #${this.state.incidence.pedido_id}`,
    //       perfil_id: "1",
    //       fecha_hora: moment().format("YYYY-MM-DD HH:mm:ss"),
    //       tipo: 5,
    //       adjunto: this.state.incidence.pedido_id,
    //     });
    //   });
    // }
    if (this.state.stagetoSend === 3) {
      await Feathers.service("rodillo").patch(this.state.incidence.rodillo_id, {
        stage: 1,
      });

      await Feathers.service("desviste").create({
        rodillo_id: this.state.incidence.rodillo_id,
      });
    }
    if (this.state.stagetoSend === 2) {
      await Feathers.service("molino").create({
        partida_id: this.state.incidence.rodillo.partida_id,
        usuario_id: this.state.incidence.usuario_id,
      });

      await Feathers.service("rodillo").patch(this.state.incidence.rodillo_id, {
        stage: 1,
      });

      await Feathers.service("desviste").create({
        rodillo_id: this.state.incidence.rodillo_id,
      });
    }
    if (this.state.stagetoSend === 4) {
      await Feathers.service("rodillo").patch(this.state.incidence.rodillo_id, {
        stage: 9,
      });

      await Feathers.service("construccion").create({
        rodillo_id: this.state.incidence.rodillo_id,
      });
    }
    if (this.state.stagetoSend === 6) {
      await Feathers.service("rodillo").patch(this.state.incidence.rodillo_id, {
        stage: 6,
      });

      await Feathers.service("desbaste").create({
        rodillo_id: this.state.incidence.rodillo_id,
      });
    }
    if (this.state.stagetoSend === 7) {
      await Feathers.service("rodillo").patch(this.state.incidence.rodillo_id, {
        stage: 7,
      });

      await Feathers.service("rectificado").create({
        rodillo_id: this.state.incidence.rodillo_id,
      });
    }

    if (this.state.stagetoSend === 10000) {
      await Feathers.service("rodillo").patch(this.state.incidence.rodillo_id, {
        stage: 12,
      });

      await Feathers.service("control_calidad").create({
        rodillo_id: this.state.incidence.rodillo_id,
      });
    }

    if (this.state.stagetoSend === 9) {
      await Feathers.service("rodillo").patch(this.state.incidence.rodillo_id, {
        stage: 5,
      });

      await Feathers.service("desmonte").create({
        rodillo_id: this.state.incidence.rodillo_id,
      });
    }

    if (this.state.stagetoSend === 10) {
      await Feathers.service("rodillo").patch(this.state.incidence.rodillo_id, {
        stage: 8,
      });

      await Feathers.service("corte").create({
        rodillo_id: this.state.incidence.rodillo_id,
      });
    }
    // TODO: add QA stage
    // DO NOT SNED
    // if (this.state.stagetoSend === git 9999) {
    //   // vamos a traer la tarea de qa a la cual se le levantó una incidencia

    //   let tarea_control_calidad = await Feathers.service(
    //     "control_calidad"
    //   ).find({
    //     query: {
    //       incidencia_id: this.state.incidence.id,
    //     },
    //   });

    //   tarea_control_calidad = JSON.parse(
    //     JSON.stringify(tarea_control_calidad.data[0])
    //   );

    //   // se va a dar como buena la trrea en control de calidad que tenia la incidencia levantada
    //   await Feathers.service("control_calidad").patch(
    //     tarea_control_calidad.id,
    //     {
    //       hora_fin: moment().format("YYYY-MM-DD HH:mm:ss"),
    //       status_tarea_id: 2,
    //     }
    //   );
    // }

    await Feathers.service("incidencia").patch(this.state.incidence.id, {
      solucion: this.state.textSolution,
    });

    await swal("¡Listo!", "¡Se ha resuelto la incidencia!", "success");

    this.fetchData();
  };

  clean = (_) => {
    this.setState({
      stagetoSend: 0,
      textSolution: "",
    });
  };

  openModal(row) {
    this.setState({
      modalOpened: true,
      currentRow: row,
    });
  }

  closeModal() {
    this.setState({
      modalOpened: false,
    });
  }

  renderForm = () => {
    return (
      <Form size={"large"}>
        {this.state.incidence.tipoincidencia.id === 24 &&
          this.state.rawMaterials && (
            <>
              {this.state.rawMaterials.every(
                (rm) => rm.total_below_min === 0
              ) ? (
                <Header
                  as="h3"
                  attached="top"
                  inverted
                  style={{
                    paddingTop: "5px",
                    paddingBottom: "5px",
                    marginBottom: "10px",
                    backgroundColor: "#21ba45",
                  }}
                >
                  <Icon name="check" />
                  <Header.Content>
                    Ya se cuenta con inventario de las materias primas faltantes, la incidencia se puede cerrar.
                  </Header.Content>
                </Header>
              ) : (
                <Form.Group widths="equal">
                  <Form.Field>
                    <h3>Proveedores de materias primas faltantes</h3>
                    {this.state.providers.length !== 0 && (
                      <Table compact>
                        <Table.Header>
                          <Table.Row>
                            <Table.HeaderCell>Proveedor</Table.HeaderCell>
                            <Table.HeaderCell>
                              Materias primas faltantes
                            </Table.HeaderCell>
                            <Table.HeaderCell>Acciones</Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>
                        <Table.Body>
                          {this.state.rawMaterials.map((rm, i) => {
                            if (rm.total_below_min)
                              return (
                                <Table.Row key={i}>
                                  <Table.Cell>{rm.proveedor}</Table.Cell>
                                  <Table.Cell>
                                    {rm.total_below_min || "N/A"}
                                  </Table.Cell>
                                  <Table.Cell>
                                    <Popup
                                      content="Enviar correo a proveedor"
                                      trigger={
                                        <Button
                                          onClick={(event) =>
                                            this.openModal(rm)
                                          }
                                          size={"tiny"}
                                          color="green"
                                          icon={"send"}
                                        />
                                      }
                                    />
                                    {/* <Popup
                              content="Enviar correo a proveedor"
                              trigger={
                                <Button
                                  onClick={async () => {
                                    await swal({
                                      title:
                                        "¿Desea enviar un correo al proveedor?",
                                      type: "warning",
                                      confirmButtonText: "OK",
                                      showCancelButton: true,
                                      reverseButtons: true,
                                      confirmButtonColor: "#3085d6",
                                      cancelButtonColor: "#d33",
                                      confirmButtonText: "Enviar",
                                      cancelButtonText: "Cancelar",
                                    }).then(async (result) => {
                                      if (result.value) {
                                        // this.setState({ loading: true });
                                        // this.setState({ loading: false });
                                      }
                                    });
                                  }}
                                  positive
                                  size={"tiny"}
                                  icon={"send"}
                                />
                              }
                            /> */}
                                  </Table.Cell>
                                </Table.Row>
                              );
                          })}
                        </Table.Body>
                      </Table>
                    )}
                  </Form.Field>
                </Form.Group>
              )}
            </>
          )}
        <Form.Group widths="equal">
          <this.renderSendTo />
          <Form.Field>
            <Form.TextArea
              label="Solución"
              placeholder="Escriba una solución..."
              onChange={(event, data) => {
                this.setState({
                  textSolution: data.value,
                });
              }}
              value={this.state.textSolution}
              fluid
            />
          </Form.Field>
        </Form.Group>
        <Form.Group>
          <Form.Field>
            <label>Responder</label>
            <Button
              fluid
              color="green"
              icon="send outline"
              onClick={() => this.handleSolveButton()}
            />
          </Form.Field>
          <Form.Field>
            <label>Limpiar</label>
            <Button
              fluid
              color="red"
              icon="eraser"
              onClick={() => this.clean()}
            />
          </Form.Field>
        </Form.Group>
      </Form>
    );
  };

  renderSendTo = () => {
    let realOptions;
    if (this.state.incidence.tipoincidencia.etapa != 2) {
      if (
        [5, 3].indexOf(this.state.incidence.rodillo.partida.producto_id) !== -1
      ) {
        realOptions = this.state.options.filter((v) => {
          if (
            v.value === 1 ||
            (v.value <= this.state.incidence.tipoincidencia.etapa &&
              v.paraMancheta === 1)
          ) {
            return v;
          }
        });
      }

      if (
        [6, 7, 8, 9, 11, 12, 14, 15].indexOf(
          this.state.incidence.rodillo.partida.producto_id
        ) !== -1
      ) {
        realOptions = this.state.options.filter((v) => {
          if (
            v.value === 1 ||
            (v.value <= this.state.incidence.tipoincidencia.etapa &&
              v.value === 10000)
          ) {
            return v;
          }
        });
      }

      if (
        [2].indexOf(this.state.incidence.rodillo.partida.producto_id) !== -1
      ) {
        realOptions = this.state.options.filter((v) => {
          if (
            v.value === 1 ||
            (v.value <= this.state.incidence.tipoincidencia.etapa &&
              v.value === 7)
          ) {
            return v;
          }
        });
      }

      if (
        [10].indexOf(this.state.incidence.rodillo.partida.producto_id) !== -1
      ) {
        realOptions = this.state.options.filter((v) => {
          if (
            v.value === 1 ||
            (v.value <= this.state.incidence.tipoincidencia.etapa &&
              v.value === 6)
          ) {
            return v;
          }
        });
      }

      if (
        [1, 4].indexOf(this.state.incidence.rodillo.partida.producto_id) !== -1
      ) {
        realOptions = this.state.options.filter((v) => {
          if (
            v.value <= this.state.incidence.tipoincidencia.etapa ||
            v.value === 1
          ) {
            return v;
          }
        });
      }

      if (this.state.incidence.tipoincidencia.id === 24) {
        realOptions = this.state.options.filter((v) => {
          if (v.value === 2 || v.value === 4) {
            return v;
          }
        });
      }

      return (
        <Form.Field>
          <label>Etapa</label>
          <Form.Dropdown
            selection
            placeholder="Selecciona Etapa"
            options={realOptions}
            name="stagetoSend"
            onChange={(event, data) => {
              this.setState({ stagetoSend: data.value });
            }}
            value={this.state.stagetoSend}
          />
        </Form.Field>
      );
    }

    return null;
  };

  renderSolucion = () => {
    return (
      <Table>
        <Table.Body>
          <Table.Row>
            <Table.Cell>Solución dada</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>{this.state.incidence.solucion}</Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  };

  renderStatus = () => {
    if (this.state.incidence.solucion === undefined) return null;
    if (!this.state.incidence.solucion) {
      return (
        <Label tag color="red">
          Abierta
        </Label>
      );
    } else {
      return (
        <Label tag color="teal">
          Cerrado
        </Label>
      );
    }
  };

  render() {
    return (
      <>
        {" "}
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <Header as={"h2"}>
                <Button
                  onClick={() => this.props.history.goBack()}
                  icon="arrow left"
                  style={{ backgroundColor: "transparent", color: "#000000" }}
                />
                Incidencia
              </Header>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row columns={this.state.incidence.imagen ? 2 : 1}>
            <Grid.Column style={{ padding: "2rem" }}>
              <Table basic="very" celled>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>
                      <h3>Información</h3>
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                {this.renderTableBody()}
              </Table>
            </Grid.Column>

            <Grid.Column style={{ padding: "2rem" }}>
              {this.renderIncidenceImage()}
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column>
              {!this.state.incidence.solucion ? (
                <this.renderForm />
              ) : (
                <this.renderSolucion />
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <CheckModal
          isOpened={this.state.modalOpened}
          data={this.state.currentRow}
          onClose={this.closeModal}
        />
      </>
    );
  }
}

export default connect(null, null, null, {
  withRef: true,
})(IncidenceCheckContainer);
